import { Text } from "@meditect/medibase-components";

export const SalesCannotCloseEmptySaleError = () => {
  return <Text>Vous ne pouvez pas clôturer une vente vide.</Text>;
};
